import React from 'react';
import type { ListItemType, ListProps } from '../List.types';
import { RootList } from './RootList';
import { RootListItem } from './RootListItem';

/**
 * A basic list component that renders items without sorting functionality.
 */
export const BasicList = <T extends ListItemType>(props: ListProps<T>) => {
  const { data, component, keyExtractor, ...rest } = props;

  return (
    <RootList {...rest}>
      {data?.map((item, index) => {
        const itemId = item.id ?? keyExtractor?.(item, index) ?? index;
        return (
          <RootListItem
            key={itemId}
            id={itemId}
            item={item}
            component={component}
          />
        );
      })}
    </RootList>
  );
};